import React from "react";
import Section from "../Components/Section";

function Accueil() {
  return (
    <>
      <Section
        titre="Alfa"
        description="Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vestibulum at ipsum hendrerit, suscipit diam quis, sagittis ante. Praesent vitae elit nunc."
        image="fond1"
        page="/Pages/Alfa"
        btnText="Explorez!"
        down="true"
      />
      <Section
        titre="Bravo"
        description="Vestibulum at ipsum hendrerit, suscipit diam quis, sagittis ante."
        image="fond2"
        page="/Pages/Bravo"
        btnText="Explorez!"
        down=""
      />
      <Section
        titre="Charlie"
        description="Lorem ipsum dolor sit amet, consectetur adipiscing elit."
        image="fond3"
        page="/Pages/Charlie"
        btnText="Explorez!"
        down=""
      />
      <Section
        titre="Delta"
        description="Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vestibulum at ipsum hendrerit, suscipit diam quis, sagittis ante."
        image="fond4"
        page="/Pages/Delta"
        btnText="Explorez!"
        down=""
      />
      <Section
        titre="Echo"
        description="Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vestibulum at ipsum hendrerit."
        image="fond5"
        page="/Pages/Echo"
        btnText="Bientôt disponible"
        down=""
      />
    </>
  );
}

export default Accueil;
